/**
 * login-history-section.tsx — "Lịch sử đăng nhập của tôi" (Cài đặt cá nhân).
 * 20 lượt gần nhất của chính người đang đăng nhập (?mine=1 — kể cả khi là admin).
 */
import { useTranslation } from 'react-i18next'
import { DataTable } from '@/components/shared/data-table'
import { ErrorState } from '@/components/shared/feedback'
import { useLoginLogs } from '@/hooks/use-audit'
import { apiError } from '@/lib/api-client'
import { LOGIN_COLUMNS } from '@/pages/settings/audit-log-tabs'

const MY_COLUMNS = LOGIN_COLUMNS.filter((c) => c.key !== 'user')

export function LoginHistorySection() {
  const { t } = useTranslation('accountPages')
  const { data, isLoading, isError, error } = useLoginLogs({ mine: true, limit: 20 })
  if (isError) return <ErrorState message={apiError(error)} />
  return (
    <div className="space-y-2">
      <DataTable
        columns={MY_COLUMNS}
        rows={data?.items ?? []}
        loading={isLoading}
        rowKey={(r) => r.id}
        emptyTitle={t('loginHistory.empty')}
      />
      <p className="text-xs text-muted-foreground">
        {t('loginHistory.hint')}
      </p>
    </div>
  )
}
